import { Card, CardContent, Typography } from '@mui/material';
import { format } from 'date-fns';
import React, { FunctionComponent } from 'react';

import { CurrentEventQuery } from '../../../../apollo/__generated__/graphql';
import { useNextMilestone } from '../../../hooks/useNextMilestone';
import { usePreviousMilestone } from '../../../hooks/usePreviousMilestone';

interface NoCurrentMilestoneCardProps {
  currentEvent: NonNullable<CurrentEventQuery['currentEvent']>;
}

export const NoCurrentMilestoneCard: FunctionComponent<
  NoCurrentMilestoneCardProps
> = ({ currentEvent }) => {
  const { milestones } = currentEvent;
  const nextMilestone = useNextMilestone(milestones);
  const previousMilestone = usePreviousMilestone(milestones);
  return (
    <Card>
      {nextMilestone !== null ? (
        <CardContent>
          <Typography variant="body1">
            Inscriptions pas encore ouvertes
          </Typography>
          <Typography variant="body2">
            {`Le ${nextMilestone.name} démarera le ${format(nextMilestone.startAt, 'dd/MM/yyyy à HH:mm')}`}
          </Typography>
        </CardContent>
      ) : previousMilestone !== null ? (
        <CardContent>
          <Typography variant="body1">Inscriptions terminées</Typography>
          <Typography variant="body2">
            {`Les inscriptions se sont terminées le ${format(previousMilestone.endAt, 'dd/MM/yyyy à HH:mm')}`}
          </Typography>
        </CardContent>
      ) : (
        <CardContent>
          <Typography variant="body2">
            {"Il n'y a pas de palier actuellement pour cet événement"}
          </Typography>
        </CardContent>
      )}
    </Card>
  );
};
